export default __webpack_public_path__ + "static/media/type_02_drk@60.eb61f591.svg";